import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=3d20a65f&"
import script from "./Matching.vue?vue&type=script&lang=ts&"
export * from "./Matching.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports